import { type ISmartCallFlowStep } from 'entities/SmartCall/api/types'
import { type ISmartCallFlowActionType } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/type'

export const getSmartCallActionTypeFromStep = (
  step: ISmartCallFlowStep
): ISmartCallFlowActionType => {
  if (step.id === 'trigger') {
    return 'incomingCall'
  }
  if (step.id === 'calling_flow') {
    return 'ring'
  }
  if (step.id === 'forward_call_multi') {
    return 'forwardCall'
  }
  if (step.id === 'success') {
    return 'callEnds'
  }
  return step.id
}
